export enum DocumentTypes {
  Undefined = 0,
  PriceOffer = 1,
  Invoice = 2,
  ProformaInvoice = 3,
  DeliveryNotes = 4,
  ReceivingNote = 5,
  ShippingNote = 6,
  ReceivedOrder = 7,
  SentOrder = 8,
  InvoiceTemplate = 9,
  ReceivedInvoice = 10,
  CashReceipt = 11,
  NonAccountingDocument = 12,
  InternalDocument = 13,
  BankNotification = 14,
  ReceivedProformaInvoice = 15,
  CreditNote = 16, // Odoslaný dobropis
  ReceivedCreditNote = 17, // Došlý dobropis
  DebitNote = 18, // Odoslaný ťarchopis
  ReceivedDebitNote = 19, // Došlý ťarchopis
  Cancellation = 20, // Storno
}
